import Text from './Text.wrapper';
import { IText } from './Text.interfaces';

export default Text;
export { Text, IText };
